import { Injectable } from '@angular/core';
import { AnalysisService } from 'app/services/analysis.service';
import { InstallationcostService } from 'app/services/installationcost.service';
import { OfferService } from 'app/services/offer.service';
import { PanelsService } from 'app/services/panels.service';
import { PricingService } from 'app/services/pricing.service';
import { RecommendationService } from 'app/services/recommendation.service';
import { SubvensionService } from 'app/services/subvension.service';
import { LatLng } from '@agm/core/services/google-maps-types';

@Injectable()
export class ReportService {

  angle: number;
  angleH: number;
  angleHLabel: string;
  roofArea: number;

  energyPrice: number;
  energyMonthlyCost: number;

  avgSunHours: number;
  insolation: number;
  insolationR: number;

  reccPower: number;
  reccArea: number;
  reccPowerCoverage: number;

  panelProd: string;
  panelModel: string;
  panelPower: number;
  panel_l: number;
  panel_w: number;
  panel_h: number;
  panelCnt: number;

  maxPower: number;
  maxArea: number;

  installationCost: number;
  savingsBrutto: number;
  savingsNetto: number;

  subvension: number;

  instalatorName: string;
  instalatorAddress: string;
  instalatorPhone: string;
  instalatorEmail: string;
  instalatorInfo: string;

  location: LatLng;


  constructor(
    private analysisService: AnalysisService,
    private installationCostService: InstallationcostService,
    private offerService: OfferService,
    private panelsService: PanelsService,
    private pricingService: PricingService,
    private recommendationService: RecommendationService,
    private subvensionService: SubvensionService
  ) { }

  collectData(): void {
    this.angle = this.analysisService.allPolygons[0].angleV;
    this.angleH = this.analysisService.allPolygons[0].angleH;
    this.angleHLabel = this.analysisService.allPolygons[0].angleHLabel;

    this.energyPrice = this.pricingService.getkWhPrice_PLN();
    this.energyMonthlyCost = this.pricingService.getMonthlyCost();

    this.avgSunHours = this.analysisService.getUslonecznienie();

    this.insolation = this.analysisService.allPolygons[0].I_g;
    this.insolationR = this.analysisService.allPolygons[0].I_gr;
    this.roofArea = this.analysisService.getRoofArea();

    this.reccPower = this.recommendationService.getMatchingPanelsPower(); // exactPanelsPower / 1000;
    this.reccArea = this.recommendationService.matchingPanelsArea;
    this.reccPowerCoverage = this.recommendationService.powerCoverage;


    this.panelProd = this.recommendationService.panelForCurrReq[0].panel.producent;
    this.panelModel = this.recommendationService.panelForCurrReq[0].panel.name;
    this.panelPower = this.recommendationService.panelForCurrReq[0].panel.powerW;
    this.panel_l = this.recommendationService.panelForCurrReq[0].panel.l;
    this.panel_w = this.recommendationService.panelForCurrReq[0].panel.w;
    this.panel_h = this.recommendationService.panelForCurrReq[0].panel.h;
    this.panelCnt = this.recommendationService.panelForCurrReq[0].cnt;

    this.maxPower = this.recommendationService.maxPanelsPower / 1000;
    this.maxArea = this.recommendationService.maxPanelsArea;

    this.installationCost = this.installationCostService.instCost;
    const sv = this.recommendationService.get20ySavings();
    this.savingsBrutto = Math.ceil(sv / 10) * 10;

    const svn = this.savingsBrutto - this.installationCostService.instCost;
    this.savingsNetto = Math.ceil(svn / 10) * 10;

    this.subvension = this.installationCost * this.subvensionService.getCurrentSubvension().doplata_procent / 100;


    this.instalatorName = this.installationCostService.offer.nazwa;
    this.instalatorAddress = this.installationCostService.offer.adres;
    this.instalatorPhone = this.installationCostService.offer.tel;
    this.instalatorEmail = this.installationCostService.offer.email;
    this.instalatorInfo = this.installationCostService.offer.info;

    this.location = this.analysisService.allPolygons[0].overlay.getPath().getAt(0);
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/report.service.ts